import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';

const MainLayout = ({ children }) => (
  <>
    {/* Keyboard users land here first; it stays hidden until focused. */}
    <Link
      to="#main"
      className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[100] focus:rounded-full focus:bg-primary focus:px-5 focus:py-3 focus:font-semibold focus:text-white"
    >
      Skip to content
    </Link>
    <Header />
    <main id="main">{children}</main>
    <Footer />
  </>
);

export default MainLayout;
